// export const CORE_API_ENDPOINT = "https://api-npi.herokuapp.com"

// Localhost 
// export const CORE_API_ENDPOINT = "http://localhost:2000"
// export const REDIRECT_O365_URI = "http://localhost:8080/login"
//export const AX_URL = "http://localhost:8080"

// // NPI UAT Server
export const CORE_API_ENDPOINT = "https://npitest.cigblusolutions.com/api"
export const REDIRECT_O365_URI = "https://npitest.cigblusolutions.com/login"
// export const AX_URL = "https://ciguat.sandbox.operations.dynamics.com"

// NPI Prod Server
// export const CORE_API_ENDPOINT = "https://npi.cigblusolutions.com/api"
// export const REDIRECT_O365_URI = "https://npi.cigblusolutions.com/login"
// export const AX_URL = "https://cib.operations.dynamics.com"

// NPI DEV Server 
// export const CORE_API_ENDPOINT = "https://npidev.cigblusolutions.com/api"
// export const REDIRECT_O365_URI = "https://npidev.cigblusolutions.com/login"
// export const AX_URL = "https://ciguat.sandbox.operations.dynamics.com"

// export const CORE_API_ENDPOINT = "/api"
// export const REDIRECT_O365_URI = "/login"

export const CLIENT_ID = "0b1bf20d-a148-44d2-8932-027dbaf66a46"
export const ACTIVE_ITEM_TAB = 6   //6
export const ACTIVE_ITEM2_TAB = 2   //6
export const VERSION_NO = "3.1.0"
// export const SYSTEM_NAME = `${(CORE_API_ENDPOINT.search("localhost") > -1) || (CORE_API_ENDPOINT.search("test") > -1) ? "NPIUAT" : "NPIPROD"}`
export const SYSTEM_NAME = `npi`



// WEBPACK FOOTER //
// ./src/lib/api.js